var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        // GET_NAVIGATION_MENU     : 'articlecategory',
        // GET_ARTICLE_PAGE_TYPE   : 'articlepagetype'
    },

    actions: keyMirror({
        UPDATE_ROUTE: null,
        CLOSE_PROFILE: null,
        BACK: null,
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
    }),
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/RoutingConstants.jsx